export default class ServerError extends Error {}
